// context/WebSocketContext.js
import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
// import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const WebSocketContext = /*#__PURE__*/createContext();
export const WebSocketProvider = ({
  children,
  url,
  maxReconnectAttempts = 50000000
}) => {
  const [socket, setSocket] = useState(null);
  const reconnectAttempts = useRef(0); //重连次数
  const heartbeatInterval = useRef(null); //心跳计时器储存
  const [key, setKey] = useState(0); // 添加 key 状态 //样式唯一id用于刷新渲染
  // const [fingerprint, setFingerprint] = useState('');
  const connectWebSocket = () => {
    const newSocket = new WebSocket(url); //+"?type=admin&token="+localStorage.getItem("Access-Token")
    // 处理连接打开事件
    newSocket.addEventListener('open', () => {
      setSocket(newSocket);
      setKey(prevKey => prevKey + 1); // 更新 key，触发重新渲染
      // const fp = await FingerprintJS.load();
      // const result = await fp.get();
      // setFingerprint(result.visitorId);
      // console.log('WebSocket连接已打开');
      // console.log('fingerprint',fingerprint)
      newSocket.send('{"type":"admin","token":"' + localStorage.getItem("Access-Token") + '"}');
      startHeartbeat(newSocket); //开始心跳
      reconnectAttempts.current = 0;
    });
    newSocket.addEventListener('message', handleMessage);
    newSocket.addEventListener('close', handleClose);
    newSocket.addEventListener('error', handleError);
    return newSocket;
  };
  //停止心跳
  const stopHeartbeat = () => {
    if (heartbeatInterval.current) {
      clearInterval(heartbeatInterval.current);
      // console.log('连接已关闭，停止心跳...');
      heartbeatInterval.current = null;
    }
  };
  //开始心跳
  const startHeartbeat = ws => {
    console.log('连接发送心跳包...');
    stopHeartbeat(); // 在启动心跳定时器前先停止之前的定时器
    heartbeatInterval.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.log('发送心跳包...');
        ws.send('{"type":"ping"}');
      } else {
        stopHeartbeat();
      }
    }, 5000); // 每10秒发送一次心跳，根据需求调整
  };

  //处理消息
  //处理消息
  const handleMessage = event => {
    try {
      const messageData = JSON.parse(event.data);
      if (messageData.type === 'error' && messageData.message === 'token不正确') {
        localStorage.setItem('userStatus', 'logout');
        stopHeartbeat();
        window.location.hash = '#/login';
      }
    } catch (error) {
      console.error('无法解析收到的消息:', event.data);
    }
  };
  const handleClose = event => {
    // console.log('WebSocket 连接已关闭:', event.code);
    stopHeartbeat();
    console.log('websocket 断开: ' + event.code + ' ' + event.reason + ' ' + event.wasClean);
    // 根据需要判断是否需要尝试重连
    if (event.code !== 1000 && reconnectAttempts.current < maxReconnectAttempts) {
      console.log('尝试重新连接...');
      reconnectAttempts.current++;
      setTimeout(() => connectWebSocket(), 1000); // 1秒后尝试重新连接
    } else {
      console.log('已达到最大重连尝试次数或连接关闭正常，停止重连。');
    }
  };
  const handleError = error => {
    console.error('WebSocket 连接发生错误:', error);
    // 在这里处理 WebSocket 连接的错误
  };
  const updateHeartbeatTimestamp = () => {
    // 这里可以添加更新连接活跃时间的逻辑
  };
  useEffect(() => {
    // const generateFingerprint = async () => {
    //   const fp = await FingerprintJS.load();
    //   const result = await fp.get();
    //   console.log('result',result)
    //   setFingerprint(result.visitorId);
    // };

    // generateFingerprint();
    connectWebSocket();
    // 组件卸载时关闭WebSocket连接和停止心跳
    return () => {
      if (socket) {
        socket.close();
        stopHeartbeat();
      }
    };
  }, []); ///留空只执行一次 url, maxReconnectAttempts

  return /*#__PURE__*/React.createElement(WebSocketContext.Provider, {
    key: key,
    value: socket
  }, children);
};
export const useWebSocket = () => {
  const socket = useContext(WebSocketContext);
  if (!socket) {
    /*#__PURE__*/ /*#__PURE__*/React.createElement("div", null, "Loading WebSocket...");
    console.log('Loading WebSocket...');
    //throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return socket;
};